module.exports = __webpack_public_path__ + "static/home_page_slider-bb4bebe775637f728c12d19fb62d4c83.png";